import React, { useContext } from "react";
import { Fade } from "react-reveal";
import "./Skills.css";

import SoftwareSkill from "../../components/softwareSkills/SoftwareSkill";
import { skillsSection } from "../../portfolio";
// import codingPerson from "../../assets/lottie/codingPerson";
import codingPerson from "../../assets/lottie/46207-programmer.json";
import DisplayLottie from "../../components/displayLottie/DisplayLottie";
import StyleContext from "../../contexts/styleContext";

const Skills = () => {
  const { isDark } = useContext(StyleContext);

  return (
    <div className={isDark ? "dark-mode main" : "main"} id="skills">
      <div className="skills-main-div">
        <Fade left duration={1200}>
          <div className="skills-image-div">
            {<DisplayLottie animationData={codingPerson} />}
          </div>
        </Fade>
        <Fade right duration={1200}>
          <div className="skills-text-div">
            <h1
              className={isDark ? "dark-mode skills-heading" : "skills-heading"}
            >
              {skillsSection.title}{" "}
            </h1>
            <p
              className={
                isDark
                  ? "dark-mode subTitle skills-text-subtitle"
                  : "subTitle skills-text-subtitle"
              }
            >
              {skillsSection.subTitle}
            </p>
            <SoftwareSkill />
            <div>
              {skillsSection.skills.map((skills, i) => {
                return (
                  <div key={i} className="skills-list">
                    <i className="fas fa-terminal" style={
                      {color: '#005092', fontSize: "1rem", marginRight: "15px"}
                    }></i>
                    <p
                      key={i}
                      className={
                        isDark
                          ? "dark-mode subTitle skills-text"
                          : "subTitle skills-text"
                      }
                    >
                      {skills}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </Fade>
      </div>
    </div>
  );
};

export default Skills;
